import React from 'react';
import { Container, Box } from '@mui/material';
import { PageIndices } from '../common/i-doc/i-doc.registry.ts';
import { DashboardLayout } from '../components/DashboardLayout';
import { AdminMetActivitiesTab } from '@pages/admin/AdminLibraryPage/AdminMetActivitiesTab';

export const AdminMetActivitiesPage: React.FC = () => {
  return (
    <DashboardLayout>
      <Container maxWidth={false} data-i-doc={PageIndices.ADMIN_MET_ACTIVITIES}>
        <Box sx={{ width: '100%' }}>
          <AdminMetActivitiesTab />
        </Box>
      </Container>
    </DashboardLayout>
  );
};
